// src/components/Profile/EditProfileModal.jsx
import React, { useState } from 'react';

export default function EditProfileModal({ user, onSave, onClose }) {
    const [formData, setFormData] = useState({
        name: user?.name || '',
        email: user?.email || '',
        phone: user?.phone || '',
        dob: user?.dob || ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            await onSave(formData);
        } catch (error) {
            console.error('Error in modal submit:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const inputStyle = {
        padding: '12px 16px',
        border: '2px solid #e5e7eb',
        borderRadius: '8px',
        fontSize: '14px',
        fontFamily: 'inherit',
        width: '100%',
        boxSizing: 'border-box',
        transition: 'all 0.3s ease',
        outline: 'none',
        backgroundColor: '#fff'
    };

    const labelStyle = {
        fontSize: '14px',
        fontWeight: 600,
        color: '#374151',
        marginBottom: '6px',
        display: 'block'
    };

    return (
        <div
            style={{
                position: 'fixed',
                top: 0, left: 0, right: 0, bottom: 0,
                background: 'rgba(0, 0, 0, 0.6)',
                backdropFilter: 'blur(4px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999,
                padding: '20px'
            }}
            onClick={onClose}
        >
            <div
                style={{
                    background: 'white',
                    borderRadius: '20px',
                    maxWidth: '500px',
                    width: '100%',
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                    overflow: 'hidden'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div style={{
                    padding: '24px 30px',
                    borderBottom: '1px solid #f3f4f6',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    background: '#fafafa'
                }}>
                    <h3 style={{ margin: 0, fontSize: '20px', fontWeight: 700, color: '#111827' }}>Edit Profile</h3>
                    <button onClick={onClose} style={{
                        background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', fontSize: '24px'
                    }}><i className="ph ph-x"></i></button>
                </div>

                <form onSubmit={handleSubmit} style={{ padding: '30px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        <div>
                            <label style={labelStyle}>Full Name</label>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                style={inputStyle}
                            />
                        </div>

                        <div>
                            <label style={labelStyle}>Email Address</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                style={inputStyle}
                            />
                        </div>

                        <div>
                            <label style={labelStyle}>Phone Number</label>
                            <input
                                type="tel"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                placeholder="Not provided"
                                style={inputStyle}
                            />
                        </div>

                        <div>
                            <label style={labelStyle}>Date of Birth</label>
                            <input
                                type="date"
                                name="dob"
                                value={formData.dob}
                                onChange={handleChange}
                                style={inputStyle}
                            />
                        </div>
                    </div>

                    <div style={{
                        marginTop: '30px',
                        display: 'flex',
                        gap: '12px',
                        justifyContent: 'flex-end'
                    }}>
                        <button
                            type="button"
                            onClick={onClose}
                            style={{
                                padding: '10px 20px',
                                borderRadius: '8px',
                                fontWeight: 600,
                                cursor: 'pointer',
                                border: '1px solid #e5e7eb',
                                background: 'white',
                                color: '#4b5563'
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            style={{
                                padding: '10px 24px',
                                borderRadius: '8px',
                                fontWeight: 600,
                                cursor: 'pointer',
                                border: 'none',
                                background: '#4b5563', // Matching the dark theme in the image
                                color: 'white',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                opacity: isSubmitting ? 0.7 : 1
                            }}
                        >
                            {isSubmitting ? (
                                <>Saving...</>
                            ) : (
                                <>
                                    <i className="ph ph-check" style={{ fontSize: '18px' }}></i>
                                    Save Changes
                                </>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
